var App = App || {};

App.SharedForm = (function ($) {
    'use strict';

    function init() {
        $("form.kentico-form").each(function (e) {
            FormLoad($(this));
            FormSubmit($(this));
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // FORM LOAD
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function FormLoad(Form) {
        // different validation tactics
        Form.find(".zag-validation-input-text").on("input", function () { ValidateText($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-radio").on("input", function () { ValidateRadio($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-checkboxes").on("input", function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-checkbox").on("input", function () { ValidateCheckbox($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-file").on("input", function () { ValidateFile($(this)); CountErrors($(this)); });

        ///Check the presence of a form in a page
        if ($('form').length > 0) {

            //Get the parameters from Url
            const urlParams = new URLSearchParams(window.location.search);
            const fieldid = urlParams.get('fieldid');
            const fieldvalue = urlParams.get('fieldvalue');
            let triggerAddress = false;

            if (fieldid && fieldvalue) {

                var field = $("[id*='" + fieldid + "']");

                if (field.length > 0) {
                    // Loop through each matching field
                    field.each(function () {
                        var elementType = $(this).prop("tagName").toLowerCase();

                        if (elementType === 'select') {
                            const $formField = $(this);
                            $formField.find('option').each(function () {
                                const optionText = $(this).text().replace(/\s+/g, '');
                                if (optionText.toLowerCase().includes(fieldvalue.toLowerCase())) {
                                    $(this).prop('selected', true).attr('selected', 'selected');
                                    $formField.trigger('change');
                                    if (triggerAddress) {
                                        showAddressFields(optionText);
                                    }
                                } else {
                                    $(this).prop('selected', false).removeAttr('selected');
                                }
                            });
                        } else if (elementType === 'input') {
                            var inputType = $(this).attr('type');
                            switch (inputType) {
                                case 'text':
                                case 'textarea':
                                    $(this).val(fieldvalue);
                                    break;
                                case 'checkbox':
                                    const checkboxLabel = $(this).next('label').text().trim().toLowerCase();
                                    if (checkboxLabel === fieldvalue.toLowerCase()) {
                                        $(this).prop('checked', true);
                                    } else {
                                        $(this).prop('checked', false);
                                    }
                                    break;
                                case 'radio':
                                    const radioValue = $(this).val();
                                    const fieldValue = decodeURIComponent(fieldvalue);
                                    const name = $(this).attr('name');

                                    if (fieldValue.toLowerCase() === radioValue.toLowerCase()) {
                                        $("input[name='" + name + "'][value='" + radioValue + "']").prop('checked', true)
                                    } else {
                                        $("input[name='" + name + "'][value='" + radioValue + "']").prop('checked', false);
                                    }
                                    break;

                                default:
                                    console.log(`Unsupported input type for field: ${fieldid}`);
                                    break;
                            }
                        }
                        else {
                            console.log(`Unsupported field type for field: ${fieldid}`);
                        }
                    });
                }
                toggleContactInformation();
            }
            // Function to show/hide and set required attribute for contact information based on  selection
            function toggleContactInformation() {
                const isCheckedYes = $('input[id*="ContactChoice"][value="Yes"]').is(':checked');
                const $contactInfoField = $('textarea[id*="ContactInformation"]');
                const $contactInfoGroup = $contactInfoField.closest('.form-group-text');

                if (isCheckedYes) {
                    $contactInfoGroup.show(); // Show the field
                    $contactInfoField.prop('disabled', false);
                    $contactInfoField.prop('required', true);
                    $contactInfoGroup.addClass('form-group-required');
                    $contactInfoGroup.find('.zag-validation-errors').html('<li class="zag-validation-error" data-ruletype="required">Kindly fill in the required field</li>'); // Add validation message
                } else {
                    $contactInfoGroup.hide(); // Completely hide the field when "No" is selected
                    $contactInfoField.prop('disabled', true);
                    $contactInfoField.prop('required', false);
                    $contactInfoGroup.removeClass('form-group-required');
                    $contactInfoGroup.find('.zag-validation-errors').empty(); // Clear validation messages
                }
            }

            // Event listener for the checkboxes to toggle contact information based on selection
            $('input[id*="ContactChoice"]').change(function () {
                toggleContactInformation();
            });
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // FORM SUBMIT
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function FormSubmit(Form) {
        // remove kentico's update and onsubmit functions
        var KenticoSubmit = Form.attr("onsubmit") || "",
            KenticoUpdate = Form.attr("data-ktc-ajax-update") || "";


        Form.removeAttr("onsubmit data-ktc-ajax-update").on("submit", function (e) {
            e.preventDefault();
            $(this).removeClass("kentico-form-loaded").addClass("kentico-form-submitted");

            // different validation tactics
            $(this).find(".zag-validation-input-text").each(function () { ValidateText($(this)); CountErrors($(this)); });
            $(this).find(".zag-validation-input-radio").each(function () { ValidateRadio($(this)); CountErrors($(this)); });
            $(this).find(".zag-validation-input-checkboxes").each(function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
            $(this).find(".zag-validation-input-checkbox").each(function () { ValidateCheckbox($(this)); CountErrors($(this)); });
            $(this).find(".zag-validation-input-recaptcha").each(function () { ValidateRecaptcha($(this)); CountErrors($(this)); });
            $(this).find(".zag-validation-input-file").each(function () { ValidateFile($(this)); CountErrors($(this)); });

            // if there are no error messages, submit the form
            if ($(this).find(".zag-validation-invalid").length > 0) {
                $(this).find(".zag-validation-invalid").first().focus();
            }
            else {
                // replace kentico's onsubmit, etc. function from attribute list and allow it to submit
                if (KenticoSubmit !== "" && KenticoUpdate !== "") {
                    $(this).attr({ "onsubmit": KenticoSubmit, "data-ktc-ajax-update": KenticoUpdate });
                    $(this).off("submit").submit().find("input[type='submit']").prop("disabled", "true");
                }
                //// if there is no onsubmit, etc. function from attribute list maybe this isn't a Kentico form so submit it
                //else {
                //    $(this).off("submit").submit();
                //}
            }
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE TEXT
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateText(Component) {
        // validate individual input against required
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
            Component.val() !== "" ? $(this).hide() : $(this).show()
        });

        // validate individual input against min-length
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='minlength']").each(function () {
            Component.val().length >= $(this).attr("data-rulemin") ? $(this).hide() : $(this).show()
        });

        // validate individual input against max-length
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='maxlength']").each(function () {
            Component.val().length <= $(this).attr("data-rulemax") ? $(this).hide() : $(this).show()
        });

        // validate individual input against compare to another field
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='compare']").each(function () {

            var Operator = $(this).attr("data-rulecomparison"),
                CompareGuid = $(this).attr("data-rulecomparisonfield"),
                CompareValue = $("[data-guid='" + CompareGuid + "']").val();

            if (Component.val() !== "" && CompareValue !== "") {
                if (Operator === "NotEqual") {
                    Component.val() !== CompareValue ? $(this).hide() : $(this).show()
                }
                else if (Operator === "Equal") {
                    Component.val() === CompareValue ? $(this).hide() : $(this).show()
                }
            }
            else {
                $(this).hide()
            }

        });

        // validate individual input against regex
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='regex']").each(function () {
            Component.val().match($(this).attr("data-ruleregex")) ? $(this).hide() : $(this).show()
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE RADIO
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateRadio(Component) {
        // because this is structured data we can assume no validation rule other than required is needed
        var ComponentName = Component.attr("name");
        var ComponentValue = $("input[name='" + ComponentName + "']:checked").val() || "";
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
        ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE CHECKBOXES
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateCheckboxes(Component) {
        // because this is structured data we can assume no validation rule other than required is needed
        var ComponentGuid = Component.attr("data-guid");
        var ComponentValue = "";

        $("input[data-guid='" + ComponentGuid + "']:checked").each(function () { ComponentValue += $(this).val() + "|"; });
        ComponentValue.trimEnd("|");

        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
        ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE CHECKBOX
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateCheckbox(Component) {
        // bool is set is the only kentico validation for this component
        var ComponentCheckbox = Component.parents(".form-group").find(".zag-validation-input-checkbox");
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='boolisset']");
        ComponentCheckbox.is(":checked") ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE FILE UPLOAD
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateFile(Component) {
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
            Component.val() !== "" ? $(this).hide() : $(this).show()
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE RECAPTCHA
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateRecaptcha(Component) {
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='recaptcha']");
        grecaptcha.getResponse().length > 0 ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // COUNT ERRORS
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function CountErrors(Component) {
        // count error messages of individual input and update ui
        Component.parents(".form-group").find(".zag-validation-errors").show();

        var ErrorContainer = Component.parents(".form-group").find(".zag-validation-errors"),
            ErrorContainerId = ErrorContainer.attr("id"),
            ErrorCount = ErrorContainer.children(".zag-validation-error:visible").length;

        if (ErrorCount > 0) {
            Component.addClass("zag-validation-invalid").attr("aria-describedby", ErrorContainerId);
            ErrorContainer.show();
        }
        else {
            Component.removeClass("zag-validation-invalid").attr("aria-describedby", "");
            ErrorContainer.hide();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SharedForm.init();
});